class r extends HTMLElement {
  constructor() {
    super(), this.sectionId = this.getAttribute("data-section-id"), this.baseUrl = this.getAttribute("data-base-url") || "/", this.lazyLoad = this.hasAttribute("data-lazy-load");
  }
  connectedCallback() {
    this.lazyLoad ? this.setUpObservers() : this.render();
  }
  setUpObservers() {
    const s = {
      root: null,
      threshold: 0.1
    }, e = new IntersectionObserver((t) => {
      t.forEach((n) => {
        n.isIntersecting && (this.render(), e.disconnect());
      });
    }, s);
    e.observe(this);
  }
  render() {
    this.dataset.loading = "true";
    const s = new URLSearchParams(window.location.search), e = `${this.dataset.baseUrl}?section_id=${this.dataset.sectionId}&${s.toString()}`;
    fetch(e).then((t) => t.text()).then((t) => {
      if (t) {
        const i = new DOMParser().parseFromString(t, "text/html").querySelector(
          `#shopify-section-${this.dataset.sectionId}`
        );
        i && (this.innerHTML = i.innerHTML || ""), this.dataset.loading = "false";
      }
    }).catch((t) => {
      console.error(`Error fetching section: ${this.sectionId}`, t), this.dataset.loading = "false";
    });
  }
}
window.customElements.define("render-section", r);
export {
  r as RenderSection
};
